import { useDemo } from "@/contexts/DemoContext";
import { useAuth } from "@/contexts/AuthContext";
import { DemoBadge } from "./DemoBadge";
import { Wallet, Clock, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

export const DemoBanner = () => {
  const { isAdmin } = useAuth();
  const { isDemoActive, demoWallet, timeRemaining, isExpired, isDemoEnabled, deactivateDemo } = useDemo();

  if (!isDemoActive || !demoWallet || !isDemoEnabled) return null;

  const formatPrice = (p: number) => `${p.toLocaleString()} DH`;

  return (
    <div className="bg-gradient-to-r from-emerald-500/10 via-sky-500/10 to-violet-500/10 border-b border-emerald-500/20">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-3">
          <DemoBadge label="DEMO MODE" variant="green" />
          <span className="text-muted-foreground hidden sm:inline">You're exploring with demo money</span>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-1.5 text-emerald-700 dark:text-emerald-400 font-medium">
              <Wallet className="w-4 h-4" />
              {formatPrice(demoWallet.balance)}
            </div>
            {!isExpired && (
              <div className="flex items-center gap-1.5 text-muted-foreground">
                <Clock className="w-3.5 h-3.5" />
                <span className="text-xs">{timeRemaining}</span>
              </div>
            )}
          </div>
          <div className="flex items-center border-l border-emerald-500/20 pl-4">
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={deactivateDemo}
              className="h-7 gap-1.5 text-xs text-emerald-700 hover:text-emerald-800 hover:bg-emerald-500/10 transition-colors"
            >
              <LogOut className="w-3.5 h-3.5" />
              Exit Demo
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
